/**
 * User: WangMeng
 * Date: 2018-08-16
 * Time: 14:05
 * Desc: 外部url链接
 */
import React from 'react';
import cns from 'classnames';

export default function OuterUrlLink({ url, text, ellip = true, className, HiddenUrl = false }) {
    // HiddenUrl 表格展示的是其它字段  点击字段打开新窗口
    return (
        url && url !== 'null' ?
            <a target="_blank" rel="noopener noreferrer" className={cns({ 'text-ellipsis block': ellip }, className)} href={url}>{text || url}</a> :
            HiddenUrl ? <span>{text}</span> : <span>--</span>
    );
}



// WEBPACK FOOTER //
// ./src/components/common/outerUrlLink/OuterUrlLink.jsx